import { IAddress } from "../common";

export class ShowRegistrationInfoDto {
  using_agent?: boolean
  agent_name?: string
  agent_phone?: string
  agent_email?: string
  agent_address?: IAddress
  agent_number?: string
  using_non_agent?: boolean
  competing_owner_handler?: boolean
  substitute_email?: string
  substitute_name?: string
  substitute_phone?: string
  leg_info?: string
  wheelchair_type?: string;
  needs_measurement?: boolean
  plan_to_earn_title?: boolean
  title?: string
  asfa_first_trial_for_hound?: boolean
  asfa_first_time_entry?: boolean
  asfa_info_changed_since_last_trial?: boolean
  asfa_info_changed_regarding?: string
  asfa_dismissed_last_6_trials?: boolean
  date_received?: Date
}
